(function () {
  function bindGallery(root) {
    var shots = root.querySelectorAll('[data-shot]');
    var thumbs = root.querySelectorAll('[data-shot-to]');
    if (!shots.length || !thumbs.length) return;

    function show(index) {
      for (var i = 0; i < shots.length; i++) {
        shots[i].hidden = shots[i].getAttribute('data-shot') !== index;
      }
      for (var j = 0; j < thumbs.length; j++) {
        if (thumbs[j].getAttribute('data-shot-to') === index) {
          thumbs[j].setAttribute('aria-current', 'true');
        } else {
          thumbs[j].removeAttribute('aria-current');
        }
      }
    }

    root.addEventListener('click', function (event) {
      var thumb = event.target.closest ? event.target.closest('[data-shot-to]') : null;
      if (!thumb || !root.contains(thumb)) return;
      event.preventDefault();
      show(thumb.getAttribute('data-shot-to'));
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      var current = root.querySelector('[data-shot-to][aria-current="true"]');
      if (!current) return;
      var list = Array.prototype.slice.call(thumbs);
      var at = list.indexOf(current);
      var next = event.key === 'ArrowRight' ? at + 1 : at - 1;
      if (next < 0 || next >= list.length) return;
      event.preventDefault();
      show(list[next].getAttribute('data-shot-to'));
      list[next].focus();
    });
  }

  function bindSort(form) {
    var select = form.querySelector('select');
    var button = form.querySelector('.im-sort-go');
    if (!select) return;
    if (button) button.hidden = true;
    select.addEventListener('change', function () {
      form.submit();
    });
  }

  function bindFilter(form) {
    var wrap = form.closest ? form.closest('.im-wrap') : null;
    if (!wrap) return;
    var grid = wrap.querySelector('[data-im-tiles]');
    if (!grid) return;
    var tiles = grid.querySelectorAll('[data-im-item]');
    var q = form.querySelector('[data-im-filter-q]');
    var era = form.querySelector('[data-im-filter-era]');
    var band = form.querySelector('[data-im-filter-year]');
    var clear = form.querySelector('[data-im-filter-clear]');
    var go = form.querySelector('[data-im-filter-go]');
    var extras = form.querySelector('[data-im-filter-extras]');
    var count = wrap.querySelector('[data-im-count]');
    var none = wrap.querySelector('[data-im-filter-none]');
    var pager = wrap.querySelector('.im-pager');
    var resting = count ? count.textContent : '';
    var noun = form.getAttribute('data-im-noun') || 'pieces';

    if (extras) extras.hidden = false;
    if (go) go.hidden = true;
    form.hidden = false;

    function apply() {
      var words = [];
      if (q && q.value) {
        words = q.value.toLowerCase().split(/\s+/).filter(Boolean);
      }
      var chosen = era && era.value ? era.value : '';
      var span = band && band.value ? band.value.split('-') : null;
      var shown = 0;
      for (var i = 0; i < tiles.length; i++) {
        var tile = tiles[i];
        var ok = true;
        var hay = tile.getAttribute('data-hay') || '';
        for (var w = 0; w < words.length; w++) {
          if (hay.indexOf(words[w]) === -1) {
            ok = false;
            break;
          }
        }
        if (ok && chosen && tile.getAttribute('data-era') !== chosen) ok = false;
        if (ok && span) {
          var year = parseInt(tile.getAttribute('data-year'), 10);
          if (isNaN(year) || year < parseInt(span[0], 10) || year > parseInt(span[1], 10)) ok = false;
        }
        tile.hidden = !ok;
        if (ok) shown++;
      }
      var active = words.length > 0 || chosen !== '' || span !== null;
      if (count) {
        if (!active) {
          count.textContent = resting;
        } else if (shown === 1) {
          count.textContent = 'One of ' + tiles.length + ' ' + noun + ' shown';
        } else {
          count.textContent = shown + ' of ' + tiles.length + ' ' + noun + ' shown';
        }
      }
      if (none) none.hidden = !active || shown > 0;
      if (pager) pager.hidden = active;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      apply();
    });
    if (q) q.addEventListener('input', apply);
    if (era) era.addEventListener('change', apply);
    if (band) band.addEventListener('change', apply);
    if (clear) {
      clear.addEventListener('click', function () {
        if (q) q.value = '';
        if (era) era.value = '';
        if (band) band.value = '';
        apply();
        if (q) q.focus();
      });
    }
  }

  function init() {
    var galleries = document.querySelectorAll('[data-im-gallery]');
    for (var i = 0; i < galleries.length; i++) {
      if (galleries[i].dataset.imBound) continue;
      galleries[i].dataset.imBound = '1';
      bindGallery(galleries[i]);
    }
    var sorts = document.querySelectorAll('[data-im-sort]');
    for (var k = 0; k < sorts.length; k++) {
      if (sorts[k].dataset.imBound) continue;
      sorts[k].dataset.imBound = '1';
      bindSort(sorts[k]);
    }
    var filters = document.querySelectorAll('[data-im-filter]');
    for (var f = 0; f < filters.length; f++) {
      if (filters[f].dataset.imBound) continue;
      filters[f].dataset.imBound = '1';
      bindFilter(filters[f]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
